<!-- eslint-disable max-len -->
<template>
  <div>
    <Card
      title="Artist Management"
    >
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="mr-2">
                <el-input placeholder="search artist name" v-model="filter" @change="searchArtist" ></el-input>
              </div>
              <Button @clicked="searchArtist" label="Apply"/>
              <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="resetArtist" /></button>
            </div>
            <Button @clicked="addArtist" label="Add Artist" variant="outline-primary"/>
          </div>
        </div>
        <data-tables-server ref="tableArtist" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom">
          </el-table-column>
          <el-table-column v-if="!isFinance" label="Actions" align="right" min-width="100px" fixed="right">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip label="Resend Email" :position="'is-right'" v-if="scope.row.email_verified_at===null && scope.row.statusCode==0">
                  <button  @click="resendEmail(scope.row)" class="p-2 w-8 mb-2 mr-2 rounded bg-orange-500 hover:bg-orange-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'envelope-square']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip label="See Detail" :position="'is-left'">
                  <a  :href="`/#/artists/detail/${scope.row.id}${scope.row.statusCode==3?'?fromDraft=1':''}`" class="inline-block p-2 w-8 mb-2 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                  </a>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="scope.row.statusCode!==2" label="Block" :position="'is-left'">
                  <button @click="blockArtist($event, scope.row)" class="p-2 w-8 mb-2 mr-2 rounded bg-red-700 hover:bg-red-800 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'ban']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="scope.row.statusCode===2" label="Unblock" :position="'is-left'">
                  <button  @click="unBlockArtist($event, scope.row)" class="p-2 w-8 mr-2 mb-2 rounded bg-green-400 hover:bg-green-500 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'circle-notch']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip label="Delete" :position="'is-left'">
                  <button v-if="!isOps && !isFinance" @click="deleteArtist($event, scope.row)"  class="w-8 mr-2 mb-2 p-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                  </button>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ModalDialogDetail from '../components/Common/ModalDialogDetail';
import { ViewProfile } from '../components/Profile';
import ListSong from '../components/Artist/ListSong';
import ListAlbum from '../components/Artist/ListAlbum';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import moment from 'moment';
import Card from '@/components/Layout/Card.vue';
import { Button } from '@/components/Layout/Form';

export default {
  name: 'ArtistPage',
  data() {
    return {
      isLoading: false,
      isShowingModal: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      total: 0,
      displayingItem: 20,
      detailArtistOpenTab: 1,
      titles: [{
        prop: {
          field: 'name',
        },
        label: 'Name',
      }, {
        prop: {
          field: 'email',
        },
        label: 'Email',
      }, {
        prop: {
          field: 'status',
        },
        label: 'Status',
      }, {
        prop: {
          field: 'verification_last_sent',
        },
        label: 'Resend Email At',
      }],
      filter: '',
      selectedRow: [],
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListArtist({ per_page: this.displayingItem, q: this.filter });
    // this.refineData();
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isOps', 'isFinance']),
    ...mapGetters('ArtistModule', ['listArtist', 'getArtist']),
  },
  watch: {
    listArtist: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.refineData();
      },
    },
  },
  methods: {
    ...mapActions('ArtistModule', ['requestListArtist', 'requestDetailArtist',
      'requestDeleteArtist', 'requestBlockArtist', 'requestUnblockArtist', 'requestResendEmail']),
    addArtist(){
      this.$router.push('/artists/add')
    },
    async searchArtist() {
      await this.requestListArtist({ per_page: 20, q: this.filter });
      this.refineData();
    },
    async resetArtist() {
      this.$refs.tableArtist.$refs.elTable.clearSort();
      this.filter = '';
      this.searchArtist();
    },
    toggleAction(event) {
      let popupaction = event.srcElement.closest('.container-action').children[1];
      if (popupaction == null) {
        popupaction = event.srcElement.closest('.container-action').children[0];
      }
      popupaction.classList.toggle('hidden');
    },

    refineData() {
      if (this.listArtist.data != undefined) {
        this.total = this.listArtist.data.total;
        this.data = this.listArtist.data.data.map((artist) => {
          let status = '';
          const statusCode = artist.status;
          switch (artist.status) {
            case 1:
              status = 'Active';
              break;
            case 2:
              status = 'Blocked';
              break;
            case 3:
              status = 'Draft';
              break;
            // eslint-disable-next-line no-fallthrough
            case 0:
            default:
              status = 'Pending';
              break;
          }
          if (artist.verification_last_sent) {
            if (this.utc_offset < 0) {
              artist.verification_last_sent = moment(artist.verification_last_sent).subtract(Math.abs(this.utc_offset), 'hour').format('YYYY-MM-DD HH:mm:ss');
            } else {
              artist.verification_last_sent = moment(artist.verification_last_sent).add(this.utc_offset, 'hour').format('YYYY-MM-DD HH:mm:ss');
            }
          }
          return Object.assign({}, artist, { status,
            statusCode });
        });
      }
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      await this.requestListArtist({ per_page: this.displayingItem, q: this.filter, sortorder, sortby, page });
    },
    async deleteArtist(event, row) {
      this.toggleAction(event);
      Vue.swal({
        title: 'Delete Data!',
        text: `Are you sure to delete artist: ${row.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestDeleteArtist(row.email);
          this.$swal('Deleted', `You successfully delete artist: ${row.name}`, 'success');
        }
      });
    },
    async blockArtist(event, row) {
      this.toggleAction(event);
      Vue.swal({
        title: 'Block Artist!',
        text: `Are you sure to block artist: ${row.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestBlockArtist(row.id);
          this.$swal('Blocked', `You successfully block artist: ${row.name}`, 'success');
        }
      });
    },
    async unBlockArtist(event, row) {
      this.toggleAction(event);
      Vue.swal({
        title: 'Unblock Artist!',
        text: `Are you sure to unblock artist: ${row.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestUnblockArtist(row.id);
          this.$swal('Unblocked', `You successfully unblock artist: ${row.name}`, 'success');
        }
      });
    },
    async resendEmail(row) {
      Vue.swal({
        title: 'Resend Email',
        text: `Are you sure to resend email verification to artist: ${row.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestResendEmail({ id: row.id });
          this.$swal('Email Send', `Email has successfully send to artist: ${row.name}`, 'success');
        }
      });
    },
  },
  components: {
    ModalDialogDetail,
    ViewProfile,
    ListSong,
    ListAlbum,
    VueCustomTooltip,
    Card,
    Button,
  },
};
</script>
<style scoped>
  .z-1000{
    z-index: 1000;
  }
  .mx-400{
    max-height: 50%;
    height: 50vh;
  }
</style>



// WEBPACK FOOTER //
// src/views/Artists.vue